import { CalendarDays, MapPin, Users } from "lucide-react";
import { StepTitle } from "@/components/register/Fields";
import { money } from "@/lib/api";

export const StepProgram = ({ camps, selected, onSelect }) => (
  <div data-testid="step-program">
    <StepTitle eyebrow="Step 1" title="Select programme" sub="Choose the programme you're registering for." />
    <div className="space-y-3">
      {camps.map((c) => (
        <button
          key={c.slug}
          type="button"
          disabled={!c.is_open}
          data-testid={`program-option-${c.slug}`}
          onClick={() => onSelect(c.slug)}
          className={`w-full text-left rounded-3xl border p-6 transition-colors disabled:opacity-50 ${selected === c.slug ? "border-[var(--accent)] bg-[var(--accent)]/[0.06]" : "border-white/10 bg-white/[0.03] hover:border-white/30"}`}
        >
          <div className="flex items-start justify-between gap-4">
            <p className="font-display font-bold text-xl tracking-tight">{c.name}</p>
            <p className="font-mono-epl accent-text shrink-0 text-right">{money(c.price_cents)}<span className="block text-[11px] text-slate-500">incl. GST · total</span></p>
          </div>
          <div className="mt-4 grid sm:grid-cols-3 gap-2 text-sm text-slate-400">
            <span className="flex gap-2 items-center"><CalendarDays size={15} />{c.dates_label} · 9 days</span>
            <span className="flex gap-2 items-center"><MapPin size={15} />{c.venue}</span>
            <span className="flex gap-2 items-center"><Users size={15} />Born 2011–2016</span>
          </div>
          <p className="mt-3 text-xs text-slate-500">{!c.is_open ? (c.sold_out ? "Sold out" : "Registrations closed") : "Per player, including GST · Elite coaching, camp T-shirt, photography & videos, player feedback"}</p>
          {c.is_open && <p className="mt-4 inline-flex rounded-full bg-[var(--accent)] text-[#070a11] px-4 py-1.5 text-sm font-bold">{selected === c.slug ? "Selected" : "Book Now"}</p>}
        </button>
      ))}
    </div>
  </div>
);
